import LXSelector from './lxSelector';

interface LXLanguageSelectorProps {
  value: Language;
  onSelect: (language: any) => void;
}

const LXLanguageSelector = (props: LXLanguageSelectorProps) => {
  return (
    <LXSelector<Language>
      dropdownHeaderWidth={100}
      dropdownItemWidth={160}
      value={props?.value}
      values={['en', 'id']}
      labels={['en', 'id']}
      onSelect={props.onSelect}
    ></LXSelector>
  );
};

export default LXLanguageSelector;
